export const ciOptions = [
    {
        text: "No data",
        fn: val => val <= 0.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#F7EFEB",
    },
    {
        text: "0 - 12 (Absent)",
        fn: val => val >= 0.0 && val <= 12.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#F7DBCB",
    },
    {
        text: "13 - 25 (Absent)",
        fn: val => val > 12.0 && val <= 25.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#EBCBBC",
    },
    {
        text: "26 - 37 (Neutral)",
        fn: val => val > 25.0 && val <= 37.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#D9D9D9",
    },
    {
        text: "38 - 50 (Neutral)",
        fn: val => val > 37.0 && val <= 50.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#C9D9D9",
    },
    {
        text: "51 - 58 (Enabling)",
        fn: val => val > 50.0 && val <= 58.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#7DA7B0",
    },
    {
        text: "59 - 66 (Enabling)",
        fn: val => val > 58.0 && val <= 66.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#6298A4",
    },
    {
        text: "67 - 83 (Enhancing)",
        fn: val => val > 66.0 && val <= 83.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#546E75",
    },
    {
        text: "84 - 100 (Enhancing)",
        fn: val => val > 83.0 && val <= 100.0,
        color: "rgba(255,255,255,1.0)",
        fillColor: "#466269",
    },
];
